import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InterventionPanel = ({ client, interventions, onMessageClient, onClose }) => {
  return (
    <div className="bg-card border border-border rounded-xl p-6 mb-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Lightbulb" size={20} className="text-primary" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-foreground">
              Intervention Plan: {client?.fullName}
            </h2>
            <p className="text-sm text-muted-foreground">AI-generated coaching strategies</p>
          </div>
        </div>
        <div className="flex gap-2">
          <Button
            variant="default"
            size="sm"
            iconName="MessageCircle"
            onClick={onMessageClient}
          >
            Message Client
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="X"
            onClick={onClose}
          >
            Close
          </Button>
        </div>
      </div>

      <div className="bg-muted/30 rounded-lg p-6">
        <div className="prose prose-sm max-w-none">
          <div className="text-muted-foreground whitespace-pre-line space-y-4">
            {interventions?.split('\n\n')?.map((section, idx) => {
              const isHeading = section?.match(/^\d+\.\s*\*\*/) || section?.match(/^\*\*.*\*\*$/);
              
              if (isHeading) {
                const headingText = section?.replace(/\*\*/g, '')?.replace(/^\d+\.\s*/, '');
                return (
                  <div key={idx} className="mb-4">
                    <h3 className="text-lg font-semibold text-foreground mb-2">{headingText}</h3>
                  </div>
                );
              }

              const lines = section?.split('\n');
              return (
                <div key={idx} className="mb-3">
                  {lines?.map((line, lineIdx) => {
                    if (line?.trim()?.startsWith('-')) {
                      return (
                        <div key={lineIdx} className="flex items-start gap-2 mb-2">
                          <Icon name="CheckCircle" size={16} className="text-primary mt-0.5 flex-shrink-0" />
                          <p className="text-sm text-foreground">{line?.replace(/^-\s*/, '')}</p>
                        </div>
                      );
                    }
                    return <p key={lineIdx} className="text-sm text-muted-foreground mb-2">{line}</p>;
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-green-500/10 border border-green-500/20 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Target" size={18} className="text-green-500" />
            <h4 className="font-semibold text-foreground">Quick Win</h4>
          </div>
          <p className="text-sm text-muted-foreground">
            Schedule a check-in call within 24 hours to rebuild connection
          </p>
        </div>
        <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Calendar" size={18} className="text-blue-500" />
            <h4 className="font-semibold text-foreground">Follow-Up</h4>
          </div>
          <p className="text-sm text-muted-foreground">
            Set reminder to check progress in 7 days and adjust plan if needed
          </p>
        </div>
        <div className="bg-purple-500/10 border border-purple-500/20 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="TrendingUp" size={18} className="text-purple-500" />
            <h4 className="font-semibold text-foreground">Success Metric</h4>
          </div>
          <p className="text-sm text-muted-foreground">
            Target: 3 completed workouts in next 7 days to rebuild momentum
          </p>
        </div>
      </div>
    </div>
  );
};

export default InterventionPanel;